module.exports = __webpack_public_path__ + "resources/img/logo_nhn_cloud_ngsc.70ce3bbbfaf5f553cc02f187748f4fbc.svg";